export const SERVICES = [
  {
    n: "01",
    slug: "custom-software",
    cta: "Discuss a build",
    to: "/contact",
    t: "Custom Software & Enterprise Applications",
    d: "Web applications, enterprise platforms, portals and business systems designed around your operations, so your teams stop working around their tools.",
    items: [
      "Web Applications",
      "Enterprise Platforms",
      "Customer & Staff Portals",
      "Order & Inventory Systems",
      "Finance & Reconciliation Tools",
      "Role-Based Dashboards",
      "API Development",
    ],
    timeline: "8 to 16 weeks for a first release",
  },
  {
    n: "02",
    slug: "digital-transformation",
    cta: "Review a process",
    to: "/contact",
    t: "Digital Transformation & Process Automation",
    d: "We map how work actually moves, then digitise, connect and automate it. AI is used where it earns its place, and plain software everywhere else.",
    items: [
      "Workflow Automation",
      "Process Digitisation",
      "System Integrations",
      "Automated Reporting",
      "SMS & WhatsApp Notifications",
      "AI & Document Processing",
      "Process Audits",
    ],
    timeline: "4 to 12 weeks",
  },
  {
    n: "03",
    slug: "government-institutional",
    cta: "See government solutions",
    to: "/government",
    t: "Government & Institutional Technology",
    d: "Systems that help ministries, agencies and public institutions manage information, run accountable workflows and deliver services more efficiently.",
    items: [
      "Citizen & Service Portals",
      "Records & Case Management",
      "Licensing & Permit Systems",
      "Revenue & Payment Tracking",
      "Multi-Site Reporting",
      "Data Migration",
      "Training & Handover",
    ],
    timeline: "Scoped to your procurement",
  },
  {
    n: "04",
    slug: "maintenance-support",
    cta: "Ask about support",
    to: "/contact",
    t: "Software Maintenance, Integration & Support",
    d: "We maintain, secure and extend the systems you depend on, whether we built them or inherited them, along with the infrastructure beneath them.",
    items: [
      "Maintenance & Monitoring",
      "Cloud Infrastructure",
      "Database Administration",
      "Security Updates & Hardening",
      "System Integration",
      "Feature Development",
      "Technical Advisory",
    ],
    timeline: "Monthly retainer",
  },
]

export const PROCESS = [
  {
    n: "01",
    t: "Discover",
    d: "We learn how your organisation runs, who uses the system and what's getting in the way.",
    tag: "We ask before we assume.",
  },
  {
    n: "02",
    t: "Define",
    d: "We turn what we've learned into clear requirements: scope, priorities, timeline and cost.",
    tag: "No surprises later.",
  },
  {
    n: "03",
    t: "Design",
    d: "We design the architecture, the workflows and the interface around those requirements.",
    tag: "Every decision has a reason.",
  },
  {
    n: "04",
    t: "Build",
    d: "Our engineers build and test the approved design in short cycles you can follow.",
    tag: "You see progress as it happens.",
  },
  {
    n: "05",
    t: "Launch",
    d: "We test with real users and real data, fix what needs fixing, train your team and go live.",
    tag: "Finished means finished.",
  },
  {
    n: "06",
    t: "Support",
    d: "After launch we maintain and improve the system, and build whatever the operation needs next.",
    tag: "Launch isn't the finish line.",
  },
]

/* ----------------------------------------------------------------------------
   The company in numbers.

   Shared by the homepage's short "who we are" block and the About page's
   numbers band, so the two can never drift apart — a visitor who reads "50+
   projects" on one page and a different figure on the other stops believing
   either.
---------------------------------------------------------------------------- */
export const STUDIO_STATS = [
  { n: "50+", l: "Projects delivered" },
  { n: "20+", l: "Businesses supported" },
  { n: "10+", l: "Industries served" },
  { n: "3+", l: "Years in operation" },
] as const
